export default {
  computed: {
    user() {
      return this.$store.getters['user/get'];
    },
    accommodations() {
      return this.user?.accommodations || [];
    },
    userBreakTime() {
      return this.getBreakTimeByCategory(this.sectionId);
    },
    userIntroTime() {
      return this.getIntroTimeByCategory(this.sectionId);
    },
    userTime() {
      return this.getTimeByCategory(this.sectionId);
    },
  },
  methods: {
    getBreakTimeByCategory(categoryId) {
      const accommodation = this.accommodations?.find(a => a.categoryId === categoryId);
      return accommodation?.breakTimeInMinutes;
    },
    getIntroTimeByCategory(categoryId) {
      const accommodation = this.accommodations?.find(a => a.categoryId === categoryId);
      return accommodation?.introTimeInMinutes;
    },
    getTimeByCategory(categoryId) {
      const accommodation = this.accommodations?.find(a => a.categoryId === categoryId);
      return accommodation?.timeInMinutes;
    },
  },
};
